export default "__VITE_ASSET__f1aab1ee__"